module.exports = __webpack_public_path__ + "img/trash.c65badc4.svg";